import React from 'react';

import { useIntl } from 'ha/i18n';
import { HOME } from 'ha/constants/pageNames';

import { usePage } from 'ha/modules/Page/contexts/PageContext';
import Track from 'ha/components/track/SmartTrack';
import Button from 'ha/ui/next/Button';

export const PricingLink: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const { name } = usePage();

  return (
    <Track name="Clicked PricingLink in NavBar" type="button">
      <Button
        color="inherit"
        data-test-locator="PricingLink Button"
        variant="text"
        href={urlResolver.getPricingTenantsUrl()}
        rel={name !== HOME ? 'no-follow' : ''}
      >
        {T('pricing_link')}
      </Button>
    </Track>
  );
};

export default PricingLink;
